const TableTitle = {
  name: "TableTitle",
  props: {
    text: {
      type: String,
      default: ""
    },
    column: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      overflowing: false
    };
  },
  watch: {
    text() {
      // 翻译或列标题变化后，等待新文本写入 DOM 再测量。
      this.$nextTick(this.updateOverflow);
    }
  },
  mounted() {
    this.updateOverflow();
    this.$nextTick(this.updateOverflow);
    this.tableCellElement = this.tableCell();
    if (this.tableCellElement) {
      this.tableCellElement.classList.add("table-title-cell");
    }
    // 监听真实表头单元格，覆盖固定宽度、minWidth/maxWidth、拖拽和重新显示。
    if (typeof ResizeObserver !== "undefined") {
      this.resizeObserver = new ResizeObserver(this.updateOverflow);
      this.resizeObserver.observe(this.tableCellElement || this.$refs.title);
    } else {
      window.addEventListener("resize", this.updateOverflow);
    }
  },
  beforeDestroy() {
    // 表头随列表销毁时释放监听，避免保留已移除的 DOM。
    if (this.resizeObserver) this.resizeObserver.disconnect();
    if (this.tableCellElement) {
      this.tableCellElement.classList.remove("table-title-cell");
    }
    window.removeEventListener("resize", this.updateOverflow);
  },
  methods: {
    tableCell() {
      const title = this.$refs.title;
      if (title && title.closest) {
        const cell = title.closest(".ivu-table-cell");
        if (cell) return cell;
      }
      return title && title.parentElement && title.parentElement.parentElement && title.parentElement.parentElement.parentElement;
    },
    // 按实际字体、内边距和布局后的可用宽度判断，不用字数估算。
    updateOverflow() {
      const title = this.$refs.title;
      this.overflowing = Boolean(title && title.clientWidth > 0 && title.scrollWidth > title.clientWidth);
    }
  },
  render(h) {
    // Tooltip 的 reference 继承此宽度，确保文本在列内单行省略。
    return h("Tooltip", {
      // 统一挂在渲染组件内部，调用方无需在每个列配置中重复声明 className。
      class: "table-title-column",
      style: {
        display: "block",
        width: "100%",
        maxWidth: "100%",
        minWidth: 0,
        overflow: "hidden",
        boxSizing: "border-box"
      },
      props: {
        content: this.text,
        disabled: !this.overflowing,
        transfer: true,
        maxWidth: 300
      },
      // 悬停时补测，兼容字体加载和不支持 ResizeObserver 的浏览器。
      nativeOn: {
        mouseenter: () => {
          this.updateOverflow();
        }
      }
    }, [h("span", {
      ref: "title",
      style: {
        display: "block",
        width: "100%",
        minWidth: 0,
        boxSizing: "border-box",
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis"
      },
      nativeOn: {
        mouseenter: () => {
          this.updateOverflow();
        }
      }
    }, this.text)]);
  }
};

// 独立工具函数没有 Vue 实例上下文，使用 renderHeader 传入的 h 创建组件。
export const renderTableTitle = (text, column, h) => {
  return h(TableTitle, {
    key: column.key || column._index,
    props: {
      text,
      column
    }
  });
};